// extracted by mini-css-extract-plugin
module.exports = {"block":"block_tz3w-"};